import { api } from "@ts/core/api";
import { Cookie } from "@ts/core/Cookie";
import { Elements } from "@ts/core/Elements";
import { simpleForm } from "@ts/core/SimpleForm";
import { HtmlData } from "@ts/data/HtmlData";
import { HtmlSection } from "@ts/sections/HtmlSection";

export function createHtmlSection(): Promise<boolean> {

    return new Promise((resolve) => {
        simpleForm('Text', 4, 'Skriv in lite text', '',
            'Du kan skriva in lite text här till att börja med och sedan fortsätta att redigera den i efterhand')
            .then(
                async (text: string) => {
                    const data = new Object as HtmlData;
                    data.htmlcode = text;
                    data.sectiontype = 'html';
                    data.subtype = 'text';
                    data.public = false;
                    data.htmlid = 0;
                    data.sectionid = 0;
                   const resp = await api<{ data: HtmlData }>('createSection', {
                        pos: Elements.contentContainer.childElementCount,
                        pagename: Cookie.pagename,
                        data: data,
                        type: 'html'
                    });
                    if (resp) {
                        const section = new HtmlSection(resp.data);
                        section.render();
                        section.enableEdit = true;
                        section.beginEdit();
                        resolve(true);
                    }
                     resolve(false);
                },
                () => {
                    resolve(false);
                }
            );
    });
}